export default __webpack_public_path__ + "static/media/tips_icon.92c49e44.svg";